module.exports = __webpack_public_path__ + "static/media/bg.58abe5ce.webp";